import { ActivityDetailResponse } from '../../app/features/activity/domain/activity.model';
import { ActivityNameStatus } from '../../app/features/activity/infrastructure/enums/activity-name-status.enum';
import { ActivityReason } from '../../app/features/activity/infrastructure/enums/activity-reason.enum';
import { ActivityType } from '../../app/features/activity/infrastructure/enums/activity-type.enum';
import { PricingItemType } from '../../app/features/activity/infrastructure/enums/pricing-item-type.enum';
import { MROType } from '../../app/features/vehicles/infrastructure/enums/mro-type.enum';

export const ActivityDetailResponseMock: ActivityDetailResponse = {
    id: 'a8e4b778-83fa-409e-815e-7a113ad7917b',
    type: ActivityType.RUC,
    status: {
        name: ActivityNameStatus.CREATED,
        dateTime: '2025-07-11T11:23:59.780307317Z',
        reason: ActivityReason.ACTIVITY_CREATED,
    },
    flags: [],
    vehicle: {
        vin: 'JH5LA9470MS016526',
        licensePlate: 'TES-1234',
        licensePlateState: 'CA',
        details: {
            make: 'Tesla',
            model: 'Model 3 Long Range',
            year: 2018,
        },
    },
    activity: {
        createdAt: '2025-07-11T11:23:59.780307317Z',
        updatedAt: '2025-07-11T11:23:59.780307317Z',
        entry: {
            timestamp: '2025-03-31T16:00:00Z',
            location: {
                name: 'Location 1',
                provider: 'Provider 1',
                address: 'Address 1',
                plazaId: 'Plaza 1',
                laneId: 'Lane 1',
                coordinates: {
                    latitude: 37.7749,
                    longitude: -122.4194,
                },
            },
        },
        exit: {
            timestamp: '2025-03-31T16:00:00Z',
            location: {
                name: 'Location 2',
                provider: 'Provider 2',
                address: 'Address 2',
                plazaId: 'Plaza 2',
                laneId: 'Lane 2',
                coordinates: {
                    latitude: 37.7749,
                    longitude: -122.4194,
                },
            },
        },
        mroType: MROType.PLUG_IN_DEVICE,
        distance: {
            total: {
                value: 2005.6,
                unit: 'mi',
            },
            taxable: {
                value: 1999.3,
                unit: 'mi',
            },
            nonTaxable: {
                value: 6.03,
                unit: 'mi',
            },
        },
        fuelConsumption: {
            taxable: {
                value: 80.22,
                unit: 'gal',
            },
            nonTaxable: {
                value: 0.4,
                unit: 'gal',
            },
        },
        pricing: {
            items: [
                {
                    type: PricingItemType.TAXABLE_MILES,
                    ratePerUnit: 0.02,
                    quantity: 1999.3,
                    unit: 'mi',
                    amount: 39.98,
                    currency: 'USD',
                },
                {
                    type: PricingItemType.FUEL_TAX_CREDIT,
                    ratePerUnit: 0.4,
                    quantity: 80.22,
                    unit: 'gal',
                    amount: -16.04,
                    currency: 'USD',
                },
            ],
            total: {
                amount: 24.06,
                currency: 'USD',
            },
        },
    },
};
